import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectCompanyIsLocked} from '../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {ROUTE_COMPANY_PROFILE_BANK_DETAILS_BY_ID} from '../../../../routes/constants'
import {selectSellerBankAccounts} from '../../../../data/seller-bank-accounts'
import DeleteButton from '../../../../features/delete-seller-bank-account'
import {SECTION_BANK_DETAILS} from '../../../../constants/sections'

export const selectBankAccountSummaryData = createSelector(
  selectSellerBankAccounts,
  selectCompanyIsLocked,
  (state: Record<string, any>) => state,
  (bankAccounts, companyIsLocked, state) => {
    const isVerified =
      selectCombinedInputFieldStatusBySectionName(state, SECTION_BANK_DETAILS) ===
      FeInputFieldStatus.VERIFIED
    const summaryData = bankAccounts.map(bankAccount => {
      const accountHolder = bankAccount?.accountHolder
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_BANK_DETAILS_BY_ID, {
          externalBankAccountId: bankAccount?.externalId,
        }),
        accountHolder: accountHolder || '',
        accountNumber: bankAccount?.accountNumber || '',
        deleteButton: companyIsLocked || isVerified ? null : DeleteButton,
        deleteProps: {target: accountHolder, externalBankAccountId: bankAccount?.externalId},
      }
    })
    return summaryData
  }
)
